export const NotesDTO = (text, testCaseId, tesResultNotes)=> {
  const comments = tesResultNotes === null ? [text] : [text, ...tesResultNotes];
  return {
    id: testCaseId,
    comments,
  }
}
